<ion-card class="ion-no-padding"
          [ngClass]="{' card--centered': isCentered, 'card--left': isLeft }">
    <ion-card-header class="ion-no-padding">
        <ion-item-divider color="primary">
            <ion-grid class="ion-no-padding">
                <ion-row class="ion-no-padding ion-text-center">
                    <ion-col class="ion-no-padding">
                        <ion-label>{{ title }}</ion-label>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <div class="refinance-toggle"
                 *ngIf="isRefinance"
                 slot="end">
                <ion-toggle mode="md"
                            color="light"
                            [disabled]="disableRefinanceSwitch"
                            [checked]="refinanceChecked"
                            (ionChange)="handleToggleChange($event)"></ion-toggle>
                <ion-grid class="ion-no-padding">
                    <ion-row class="ion-no-padding">
                        <ion-col class="ion-no-padding" size="6">
                            <ion-text>Cash</ion-text>
                        </ion-col>
                        <ion-col class="ion-no-padding" size="6">
                            <ion-text>Finance</ion-text>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-item-divider>
    </ion-card-header>
    <ion-card-content>
        <form [formGroup]="form">
            <ion-grid class="ion-no-padding"
                      [ngClass]="{ 'card__section': !l }"
                      *ngFor="let section of sections; let l = last;">
                <ion-row class="ion-padding-top ion-align-items-center"
                         *ngFor="let field of section!.fields"
                         [ngClass]="{ 'row--highlight': field.highlight }">
                    <!-- Label Column -->
                    <ion-col class="label-col ion-no-padding ion-align-self-center"
                             *ngIf="field.type === 'INPUT'">
                        <ion-text>{{ field.label }}:</ion-text>
                        <ion-note>{{ field.subLabel || '( ' + field.unit + ' )'}}</ion-note>
                    </ion-col>

                    <!-- INPUT -->
                    <ion-col class="input-col ion-no-padding ion-align-self-center ion-text-end"
                             *ngIf="field.type === 'INPUT'">
                        <ion-input class="ion-text-end"
                                   [ngClass]="{ 'input--invalid': field.formControl!.invalid }"
                                   id="{{ field.id }}"
                                   type="text"
                                   name="{{ field.id }}"
                                   aria-label="Input Value"
                                   mode="ios"
                                   inputmode="text"
                                   (ionFocus)="inputFocus(field)"
                                   (ionBlur)="inputBlur(field)"
                                   formControlName="{{ field.id }}"></ion-input>
                    </ion-col>

                    <!-- Label Column -->
                    <ion-col class="label-col ion-no-padding"
                             *ngIf="field.type === 'OUTPUT'">
                        <ion-text>{{ field.label }}:</ion-text>
                        <ion-note>{{field.subLabel}}</ion-note>
                    </ion-col>

                    <!-- OUTPUT -->
                    <ion-col class="output-col ion-no-padding ion-text-end"
                             *ngIf="field.type === 'OUTPUT'">
                        <ion-text *ngIf="field.unit === '$'">
                            {{ field.outputValue | currency: 'USD' | hideInfinity }}
                        </ion-text>
                        <ion-text *ngIf="field.unit === '%'">
                            {{ field.outputValue | percent: '1.1-2' | hideInfinity }}
                        </ion-text>
                        <ion-text *ngIf="field.unit !== '%' && field.unit !== '$'">
                            {{ field.outputValue }}
                        </ion-text>
                    </ion-col>

                    <!-- Label Column -->
                    <ion-col class="label-col ion-no-padding"
                             *ngIf="field.type === 'IN_AND_OUT'">
                        <ion-text>{{ field.label }}:</ion-text>
                        <ion-note>{{ field.subLabel || '( ' + field.unit + ' )'}}</ion-note>
                    </ion-col>
                    <!-- IN_AND_OUT -->
                    <ion-col class="input-col ion-no-padding ion-align-self-center ion-text-end"
                             *ngIf="field.type === 'IN_AND_OUT'">
                        <ion-input class="ion-text-end"
                                   [ngClass]="{ 'input--invalid': field.formControl!.invalid }"
                                   id="{{ field.id }}"
                                   type="text"
                                   name="{{ field.id }}"
                                   aria-label="Input Value"
                                   mode="ios"
                                   inputmode="text"
                                   (ionFocus)="inputFocus(field)"
                                   (ionBlur)="inputBlur(field)"
                                   formControlName="{{ field.id }}"></ion-input>
                        <ion-text>
                            <!-- Assuming all IN_AND_OUTs are % in and Dollar out  -->
                            {{ field.outputValue | currency: 'USD' | hideInfinity }}
                        </ion-text>
                    </ion-col>

                    <!-- OUT_FOOTER -->
                    <ion-col class="output-col output-col--footer ion-no-padding ion-text-center"
                             *ngIf="field.type === 'OUT_FOOTER'">
                        <ion-text>
                            <!-- Assuming all OUT_FOOTERs are of Dollar Unit  -->
                            {{ field.label }}: {{ field.outputValue | currency: 'USD' | hideInfinity }}
                        </ion-text>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </form>
    </ion-card-content>
</ion-card>
